import script from "./NoDataMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoDataMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./NoDataMolecule.css?vue&type=style&index=0&Scoped=true&lang=css&external"

const __exports__ = script;

export default __exports__